// apps/web/src/main.tsx — Fase 01, Plano 39 (NFR-08/NFR-09).
//
// Entrypoint real do browser: monta a árvore React no #root declarado em
// index.html. Nenhum estado de sessão vive aqui nem em nenhum módulo
// importado por este arquivo — sessão é cookie HttpOnly emitido pelo backend
// (ADR-003); Web Storage (localStorage/sessionStorage) é proibido por
// SEC-001 §13.4 para sessão/token. Única exceção: preferências visuais em
// desenvolvimento (ex.: aviso de /admin/perfis), desligadas no build de produção.
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AppRouter } from './router';
import { ToastProvider } from './components/ui/toast';
import './styles/tokens.css';
import './styles/premium.css';
import './styles/painel-tokens.css';
import './styles/painel-perfis.css';
import { AppearanceProvider } from './components/shell/appearance';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Elemento #root não encontrado em index.html — entrypoint não pode montar a aplicação.');
}

createRoot(rootElement).render(
  <StrictMode>
    <AppearanceProvider><ToastProvider>
      <AppRouter />
    </ToastProvider></AppearanceProvider>
  </StrictMode>,
);
